var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmanecer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_542",
    "data-name": "Group 542",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.454,
    height: 11.157,
    viewBox: "0 0 16.454 11.157",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_498",
    "data-name": "Rectangle 498",
    width: 16.454,
    height: 11.157,
    fill: "#000"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_536",
    "data-name": "Group 536",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1337",
    "data-name": "Path 1337",
    d: "M0,2.052V.293a.293.293,0,1,1,.586,0V2.052a.293.293,0,0,1-.586,0",
    transform: "translate(7.938 1.18)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1338",
    "data-name": "Path 1338",
    d: "M.01,1.2a.292.292,0,0,0,.359.207L3.484.577A.293.293,0,0,0,3.332.01L.217.845A.293.293,0,0,0,.01,1.2Z",
    transform: "translate(12.753 5.805)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1339",
    "data-name": "Path 1339",
    d: "M.147,2.07a.293.293,0,0,0,.4-.108L1.427.438A.293.293,0,0,0,.919.145L.039,1.67a.293.293,0,0,0,.107.4Z",
    transform: "translate(10.43 2.09)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1340",
    "data-name": "Path 1340",
    d: "M1.671.04.148.92h0a.293.293,0,1,0,.293.508L1.966.548A.293.293,0,1,0,1.673.04Z",
    transform: "translate(12.253 4.557)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1341",
    "data-name": "Path 1341",
    d: "M.086,2.777a.293.293,0,0,0,.415,0L2.781.5h0A.293.293,0,0,0,2.367.082L.085,2.364a.293.293,0,0,0,0,.413Z",
    transform: "translate(11.463 2.128)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1342",
    "data-name": "Path 1342",
    d: "M.218,3.692h0a.3.3,0,0,0,.076.01.293.293,0,0,0,.283-.218L1.412.369A.293.293,0,0,0,.846.217L.01,3.333a.293.293,0,0,0,.207.359Z",
    transform: "translate(9.228 0)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1343",
    "data-name": "Path 1343",
    d: "M.147.548l1.525.88A.293.293,0,1,0,1.965.92L.441.04A.293.293,0,1,0,.148.548Z",
    transform: "translate(2.098 4.557)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1344",
    "data-name": "Path 1344",
    d: "M.227.579l3.114.835A.293.293,0,1,0,3.493.847L.378.012a.293.293,0,1,0-.15.566Z",
    transform: "translate(0 5.803)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1345",
    "data-name": "Path 1345",
    d: "M12.008.057a3.528,3.528,0,0,1,.6-.057c1.529,0,2.888,1.5,3.76,2.765h0a.293.293,0,1,1-.483.333C15.235,2.16,13.948.586,12.606.586a3.073,3.073,0,0,0-.755.1h0c-.117.029-.231.065-.346.105l-.094.036c-.079.029-.159.062-.238.1l-.117.051q-.12.055-.239.115l-.088.044c-.1.052-.2.106-.3.163-.053.029-.106.059-.159.09l-.164.1-.184.108-.038.023-.24.144c-.253.152-.514.305-.779.455h0a5.072,5.072,0,0,0,1.986.429.293.293,0,1,1,0,.586,5.975,5.975,0,0,1-2.635-.667l0,0-.132-.067c-.018-.009-.035-.019-.052-.029-.205-.1-.406-.215-.6-.327l-.048-.029c-.192-.111-.38-.224-.563-.334l-.035-.021q-.235-.141-.464-.276l-.16-.093-.16-.091c-.1-.056-.2-.111-.3-.163L5.6,1.087Q5.482,1.027,5.361.97L5.247.919c-.08-.035-.16-.067-.24-.1L4.914.788A2.285,2.285,0,0,0,4.651.7L4.565.682h0a3.075,3.075,0,0,0-.755-.1C2.469.586,1.181,2.16.533,3.1a.293.293,0,0,1-.483-.333C.922,1.5,2.282,0,3.81,0h0a3.528,3.528,0,0,1,.6.057L4.658.09a.548.548,0,0,1,.117.029L4.986.2A.067.067,0,0,0,5,.2a6.516,6.516,0,0,1,1,.433l.1.052c.138.074.275.151.413.231L6.6.965q.239.14.481.286l.075.045q.2.121.406.242l.16.091q.189.109.384.213l.107.057q.189-.1.374-.205c.059-.033.117-.063.173-.1.2-.115.393-.231.584-.347q.243-.147.484-.288L9.9.918q.208-.121.415-.232l.1-.051a6.472,6.472,0,0,1,1-.433L11.433.2Z",
    transform: "translate(0.023 7.93)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1346",
    "data-name": "Path 1346",
    d: "M.577,3.713a3.225,3.225,0,0,1,6.447,0L7.6,3.575a3.807,3.807,0,0,0-7.6,0",
    transform: "translate(4.432 4.412)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1347",
    "data-name": "Path 1347",
    d: "M.918,1.963a.293.293,0,1,0,.508-.293L.546.145A.293.293,0,0,0,.038.438Z",
    transform: "translate(4.567 2.09)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1348",
    "data-name": "Path 1348",
    d: "M2.363,2.776a.293.293,0,1,0,.415-.413L.5.082A.293.293,0,0,0,.082.5Z",
    transform: "translate(2.137 2.13)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1349",
    "data-name": "Path 1349",
    d: "M.845,3.484h0a.293.293,0,0,0,.283.218.3.3,0,0,0,.076-.01.293.293,0,0,0,.207-.359L.577.217A.293.293,0,0,0,.01.369Z",
    transform: "translate(5.813 0)",
    fill: "#000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmanecer);
export default __webpack_public_path__ + "static/media/amanecer.c952b4764eee29d090479013c23ccaa3.svg";
export { ForwardRef as ReactComponent };